const exporttrack ='Clicked on the '
export default exporttrack; 